import { createSlice } from '@reduxjs/toolkit';
import {
  activatePartnerUserBuilder,
  approveProductBuilder,
  deleteItemBuilder,
  editItemBuilder,
  fetchCategoriesBuilder,
  fetchMarketplaceCategoriesBuilder,
  fetchPartnersItemsBuilder,
  fetchPartnerUsersBuilder,
  fetchSectionsBuilder,
  getProductByIdBuilder,
  toggleItemAvailabilityBuilder,
} from './builder';

const initialState = {
  partnerUsers: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
    perPage: 0,
  },

  partnersItems: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
    perPage: 0,
  },

  categories: [],
  sections: [],
  marketplaceCategories: [],

  selectedProduct: {},

  fetchPartnerUsersPending: false,
  activatePartnerUserPending: false,
  fetchPartnersItemsPending: false,
  fetchCategoriesPending: false,
  fetchMarketplaceCategoriesPending: false,
  fetchSectionsPending: false,
  approveProductPending: false,
  getProductByIdPending: false,

  editItemPending: false,
  toggleItemAvailabilityPending: false,
  deleteItemPending: false,
};

export const partnersSlice = createSlice({
  name: 'partnersInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    fetchPartnerUsersBuilder(builder);
    activatePartnerUserBuilder(builder);
    fetchPartnersItemsBuilder(builder);
    fetchCategoriesBuilder(builder);
    fetchMarketplaceCategoriesBuilder(builder);
    fetchSectionsBuilder(builder);
    approveProductBuilder(builder);
    getProductByIdBuilder(builder);
    editItemBuilder(builder);
    toggleItemAvailabilityBuilder(builder);
    deleteItemBuilder(builder);
    builder.addCase('logout', () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = userSlice.actions;

export const selectPartnerUsers = state => state.partnersInfo.partnerUsers;
export const selectFetchPartnerUsersPending = state => state.partnersInfo.fetchPartnerUsersPending;

export const selectActivatePartnerUserPending = state => state.partnersInfo.activatePartnerUserPending;

export const selectPartnersItems = state => state.partnersInfo.partnersItems;
export const selectFetchPartnersItemsPending = state => state.partnersInfo.fetchPartnersItemsPending;

export const selectCategories = state => state.partnersInfo.categories;
export const selectMarketplaceCategories = state => state.partnersInfo.marketplaceCategories;
export const selectSections = state => state.partnersInfo.sections;
export const selectApproveProductPending = state => state.partnersInfo.approveProductPending;

export const selectSelectedProduct = state => state.partnersInfo.selectedProduct;

export const selectGetProductByIdPending = state => state.partnersInfo.getProductByIdPending;

export const selectEditItemPending = state => state.partnersInfo.editItemPending;
export const selectToggleItemAvailabilityPending = state => state.partnersInfo.toggleItemAvailabilityPending;
export const selectDeleteItemPending = state => state.partnersInfo.deleteItemPending;

export default partnersSlice.reducer;
